const meta = {
  'invite-members': 'Invite members',
  sso: 'Single sign-on',
};

export default meta;
